<template>
  <header>
    <!-- 导航栏 -->
    <nav class="bg-white shadow-md fixed w-full z-50">
      <div
        class="container mx-auto px-6 flex items-center justify-between h-16"
      >
        <!-- 左侧Logo区域 -->
        <div class="flex items-center">
          <div class="flex items-center">
            <img
              src="../assets/headerlog.png"
              class="h-10 mr-2"
            />
            <span class="font-bold text-xl text-blue-800">创达芯仪</span>
          </div>
        </div>
        <!-- 导航菜单 -->
        <div class="hidden md:flex items-center space-x-8">
        
        <div class="div-border-hover">
        <router-link to="/">首页</router-link>
        </div>
        <div class="div-border-hover">
        <router-link to="/about">关于创达</router-link>
       </div>
       <div class="div-border-hover">
        <router-link to="/product">产品与服务</router-link>
         </div>
         <div class="div-border-hover">
        <router-link to="/news"> 新闻中心</router-link>       
         </div> 
        <div class="div-border-hover">
        <router-link to="/partner"> 合作伙伴</router-link>
         </div>
        <div class="div-border-hover">
        <router-link to="/contactus"> 联系我们 </router-link>
       </div>
         
        </div>
        <!-- 移动端菜单按钮 -->
        <div class="md:hidden flex items-center app-icon" @click="drawer = true" v-if="isMobile">
          <svg t="1744349127498" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4615" width="24" height="24"><path d="M133.310936 296.552327l757.206115 0c19.781623 0 35.950949-16.169326 35.950949-35.950949 0-19.781623-15.997312-35.950949-35.950949-35.950949L133.310936 224.650428c-19.781623 0-35.950949 16.169326-35.950949 35.950949C97.359987 280.383 113.529313 296.552327 133.310936 296.552327z" fill="#707070" p-id="4616"></path><path d="M890.51705 476.135058 133.310936 476.135058c-19.781623 0-35.950949 16.169326-35.950949 35.950949 0 19.781623 16.169326 35.950949 35.950949 35.950949l757.206115 0c19.781623 0 35.950949-16.169326 35.950949-35.950949C926.467999 492.304384 910.298673 476.135058 890.51705 476.135058z" fill="#707070" p-id="4617"></path><path d="M890.51705 727.447673 133.310936 727.447673c-19.781623 0-35.950949 15.997312-35.950949 35.950949s16.169326 35.950949 35.950949 35.950949l757.206115 0c19.781623 0 35.950949-15.997312 35.950949-35.950949S910.298673 727.447673 890.51705 727.447673z" fill="#707070" p-id="4618"></path></svg>
        </div>
      </div>
    
      <!-- 移动端菜单 -->
      <div
        v-if="drawer"
        class="drawer-box"
        @click="drawer = false" 
      >
        <div class="drawer-center-box" >
          <div>
            <router-link to="/">首页</router-link>
          </div>
          <div>
            <router-link to="/about">关于创达</router-link>
          </div>
          <div>
            <router-link to="/product">产品与服务</router-link>
          </div>
          <div>
            <router-link to="/news"> 新闻中心</router-link>        
          </div>
          <div>
            <router-link to="/partner"> 合作伙伴</router-link>
          </div>
          <div>
            <router-link to="/contactus"> 联系我们</router-link>
          </div>
        </div>
      </div>
    </nav>
   
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
     drawer:false, 
     isMobile:'80%',
    } 
  },
  mounted() {
    // 实时检测窗口变化
    this.check();
    window.addEventListener('resize', this.check);
  },
   methods: {
      
      check() {
        // 通过窗口宽度判断
        this.isMobile = window.innerWidth <= 768;
        // console.log(this.isMobile );
        
      }
   }
  
}
</script>

<style scoped>

/* 导航栏活跃项样式 */
.nav-item.active {
  color: #1d4ed8;
}
/* 输入框样式覆盖 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}
/* 确保页面最小高度 */
body {
  min-height: 1024px;
}
.app-icon{
  width: 50px;
  height: 100%;
  /* background: pink; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
   -webkit-tap-highlight-color: transparent; /* 针对移动端 */
  outline: none; /* 清除焦点轮廓 */
  user-select: none; /* 可选：禁止文字选中 */
}

.drawer-box{
  position: fixed;
  top: 0;
  left: 0 ;
  width: 100vw;
  height: 100vh;
  background: rgba(17, 15, 15, 0.69);
  z-index: 9999;

}
.drawer-center-box{
  position: absolute;
  right: 0;
  width: 70%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: flex-start; /* 新增 */
}
.drawer-center-box div{
  margin: 1rem;
  padding: 0.1rem;
  color: #333333;
  flex-shrink: 0;
  border-bottom: 2px solid #1d4fd800
}
.drawer-center-box div:hover {
  border-bottom: 2px solid rgb(29 78 216);
  transition: all 0.5s ease;
}



.div-border-hover {
 flex-shrink: 0;
 border-bottom: 2px solid #1d4fd800
}

.div-border-hover:hover {
 border-bottom: 2px solid rgb(29 78 216);
transition: all 0.5s ease;
}
</style>